// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import axios from 'axios';
import { inject, observer } from "../../../../stores/mobx-compat";

import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Alert from '../../../ui/Alert';
import Modal, { ModalActions } from '../../../ui/Modal';
import FileUpload from '../../../ui/FileUpload';
import { UploadIcon, DownloadIcon } from '../../../ui/icons';
import { API_URL } from '../../../../configs';

class Unsubscribes extends Component {
  state = { modalOpen: false, files: [], loading: false };

  getList = async () => {
    try {
      this.setState({ loading: true });
      const csv = '"address","created_at"\n';
      const { data } = await axios.get(`${API_URL}/api/em/do-not-mail?emailDomain=${this.props.store.emailManagement.activeEmailDomainName}`);
      if (data.success) {
        const list = data.data.mailgunRes.items.reduce(
          (acc, cur) => `${acc}"${cur.address}","${cur.created_at}"\n`, csv,
        );
        this.link.href = `data:text/csv,${encodeURI(list)}`;
        this.link.download = 'unsubscribes.csv';
        this.link.click();
      } else {
        this.props.store.failure('Something went wrong…');
      }
    } catch (e) {
      this.props.store.failure('Something went wrong…');
    } finally {
      this.setState({ loading: false });
    }
  }

  closeModal = () => this.setState({ modalOpen: false, files: [] });

  render() {
    const sup = this.props.store.emailSuppression;
    return (
      <>
        <a ref={(link) => { this.link = link; }} style={{ display: 'none' }} />

        <Card padded className="mb-5">
          <CardHead title="Upload unsubscribes CSV" />
          <Alert tone="info">
            Each email address should be on its own line. Duplicate addresses will be overwritten.
          </Alert>
          <div className="mt-3 flex justify-end">
            <Button
              variant="primary"
              icon={UploadIcon}
              onClick={() => this.setState({ modalOpen: true })}
            >
              Upload unsubscribes CSV
            </Button>
          </div>
        </Card>

        <Card padded>
          <CardHead title="Download unsubscribes CSV" />
          <div className="flex justify-end">
            <Button
              icon={DownloadIcon}
              loading={this.state.loading}
              disabled={this.state.loading}
              onClick={this.getList}
            >
              Download unsubscribes CSV
            </Button>
          </div>
        </Card>

        <Modal
          open={this.state.modalOpen}
          onClose={this.closeModal}
          size="lg"
          title="Upload do-not-mail CSV"
          icon={UploadIcon}
          actions={(
            <>
              <Button
                onClick={() => {
                  const a = document.createElement('a');
                  a.href = `data:text/csv,${encodeURI('john@aol.com\nchris@gmail.com\ntest@test.com')}`;
                  a.download = 'sample.csv';
                  a.click();
                }}
              >
                Download sample
              </Button>
              <ModalActions
                onCancel={this.closeModal}
                onConfirm={async () => {
                  await sup.uploadCSV(this.state.files);
                  this.closeModal();
                }}
                confirmLabel="Upload"
                confirmLoading={sup.loading}
                confirmDisabled={this.state.files.length === 0}
              />
            </>
          )}
        >
          <p className="m-0 mb-3 text-[13px] text-mov-ink-soft">
            Upload a list of emails separated by newline.
          </p>
          <FileUpload
            files={this.state.files}
            onChange={(files) => this.setState({ files })}
            accept=".csv"
            maxFiles={1}
            maxSize={10 * 1024 * 1024}
            note="MAX 1 CSV · ≤10MB · .csv"
          />
        </Modal>
      </>
    );
  }
}

export default inject('store')(observer(Unsubscribes));
